import script from "./RateForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RateForm.vue?vue&type=script&setup=true&lang=js"

import "./RateForm.vue?vue&type=style&index=0&id=263ddd63&lang=scss&scoped=true"

import exportComponent from "C:\\Frontend\\Projects\\interactive-rating-component-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-263ddd63"]])

export default __exports__